import React, { useEffect } from "react";
import { Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BannerImage from "./E.png";
import { useNavigate } from "react-router-dom";

const ExperianInsurance = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate("/");
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 9999,
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* 🔲 Background Blur Layer (only the image) */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 0,
          overflow: "hidden",
          pointerEvents: "none", // ⛔ prevent interfering with clicks
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundImage: `url(${BannerImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "blur(12px)",
            transform: "scale(1.05)", // slight scale to reduce blur cropping
          },
        }}
      />

      {/* ✅ Foreground Container */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
          maxWidth: { xs: "90%", sm: "80%", md: "60%" },
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1,
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            color: "#000",
            zIndex: 2,
            "&:hover": {
              color: "#000",
            },
          }}
        >
          <CloseIcon sx={{ fontSize: { xs: 14, md: 20 }, fontWeight: "bold" }} />
        </IconButton>

        {/* Main Banner Image */}
        <Box
          component="img"
          src={BannerImage}
          alt="Experian Banner"
          sx={{
            width: "100%",
            height: "auto",
            objectFit: "contain",
            borderRadius: 2,
            boxShadow: "0 0 20px rgba(0, 0, 0, 0.5)",
          }}
        />
      </Box>
    </Box>
  );
};

export default ExperianInsurance;
